export function isHTMLElement(node) {
    return node instanceof Node && node.nodeType === Node.ELEMENT_NODE;
}
export function isHTMLAnchorElement(element) {
    return isHTMLElement(element) && element.nodeName === 'A';
}
export function isHTMLInputElement(element) {
    return isHTMLElement(element) && element.nodeName === 'INPUT';
}
export function isHTMLButtonElement(element) {
    return isHTMLElement(element) && element.nodeName === 'BUTTON';
}
export function isHTMLSelectElement(element) {
    return isHTMLElement(element) && element.nodeName === 'SELECT';
}
export function isHTMLTextAreaElement(element) {
    return isHTMLElement(element) && element.nodeName === 'TEXTAREA';
}
//# sourceMappingURL=element.js.map